import CustomLink from "shared/ui/typography/CustomLink";
import Text from "shared/ui/typography/Text";

const FullyPaid = () => {
  return (
    <Text className="gg-col-span-12 gg-mb-12 xl:gg-mb-0 xl:gg-col-span-6 xl:gg-pr-12 gg-text-sm sm:gg-text-base">
      Hallo! Volgens onze gegevens heb je de betaling reeds voldaan. Je hoeft op
      dit moment niets meer te doen. Heb je toch een vraag? Neem dan contact op
      met onze klantenservice. Dat kan telefonisch via{" "}
      <a className={"gc-underline"} href="tel:010 307 2889">
        010 307 2889
      </a>{" "}
      of per e-mail via{" "}
      <CustomLink
        // className={"gc-underline"}
        to="mailto:klantenservice@gewoongers.nl"
      >
        klantenservice@gewoongers.nl
      </CustomLink>
    </Text>
  );
};
export default FullyPaid;
